module.exports = __webpack_public_path__ + "assets/img/read.svg";